import React, { ButtonHTMLAttributes, FC, HTMLAttributes, ReactElement } from 'react';
import { BadgeNotification } from 'src/domains/common/components/badge/badge';
import { cn } from 'src/domains/common/components/utils';

// Tab List

interface TabListType extends HTMLAttributes<HTMLDivElement> {
    dataTest?: string;
}

export const TabList: FC<TabListType> = ({ children, className, dataTest, ...props }): ReactElement => {
    return (
        <div
            className={cn('flex h-9 rounded-lg bg-muted p-1 text-muted-foreground', className)}
            data-test={dataTest}
            {...props}
        >
            {children}
        </div>
    );
};

// Tab Trigger

interface TabTriggerType extends ButtonHTMLAttributes<HTMLButtonElement> {
    active: boolean;
    notifications?: number;
    dataTest?: string;
}

export const TabTrigger: FC<TabTriggerType> = ({
    children,
    active,
    disabled,
    notifications,
    className,
    dataTest,
    ...props
}): ReactElement => {
    return (
        <button
            className={cn(
                'font-tertiary inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm text-foreground font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border-0 gap-1 cursor-pointer bg-transparent',
                active && 'bg-background',
                disabled === true && 'pointer-events-none opacity-50',
                className
            )}
            data-test={dataTest}
            {...props}
        >
            <span>{children}</span>
            {notifications !== undefined && notifications > 0 && <BadgeNotification value={notifications} />}
        </button>
    );
};
